// @flow
import * as React from 'react';
import { RadioButtonsField } from 'components/Form';
import { BodySmall } from 'components/Text';
import { trackClicked } from 'utils/analytics';

const EnableAtsField = ({
  orgId,
  listingType
}: {
  orgId: string,
  listingType: string
}) => (
  <>
    <RadioButtonsField
      label={getText('Type of Application')}
      description={
        <BodySmall mb={24}>
          {getText(
            `Would you like applicants to apply directly to this listing? This allows you to manage and track applicants in your dashboard via Idealist Easy Apply. Each application includes: Name, Email, Resume, and up to 5 other documents.`
          )}
        </BodySmall>
      }
      columns={2}
      large
      name="hasAts"
      buttons={[
        {
          label: getText(`Use Idealist Easy Apply`),
          value: true
        },
        {
          label: getText(`No, don't track applicants`),
          value: false
        }
      ]}
      onUpdateValue={value =>
        trackClicked('Enable ATS - Admin', {
          enable: value,
          org_id: orgId,
          listing_type: listingType
        })
      }
    />
  </>
);

export default EnableAtsField;
